import React, { useEffect, useState } from "react";
import { Card, Table, Modal, notification, Input } from "antd";
import { Row, Col } from "react-bootstrap";
import { SearchOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import { useDispatch, useSelector } from "react-redux";
import SubscriptionEditModel from "../components/Modals/SubscriptionEditModel";
import * as type from "../store/types";
import PlanCutomizModel from "../components/Modals/PlanCutomizModel";
import moment from "moment";

const Customizedplan = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null); // State to store the selected row's _id
  const [subscriptions, setSubscriptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch Data from API
  const fetchCostomList = async () => {
    try {
      // Live
      // const response = await fetch(`https://euctostaging.com/lms/api/businessinitialform/customuser`);
      // Test
      const response = await fetch(
        `https://euctostaging.com/lms/api/businessinitialform/customuser`,
      );
      if (response.ok) {
        const result = await response.json();
        setSubscriptions(result.data); // Map `data` array to the table's `dataSource`
        setIsLoading(false);
      } else {
        const errorData = await response.json();
        notification.error({
          message: "Error",
          description: errorData.message || "Failed to fetch data.",
        });
        setIsLoading(false);
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Something went wrong while fetching data.",
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCostomList();
  }, []);

  // Define columns for the Ant Design Table
  const columns = [
    {
      title: "IST Appointment Time",
      dataIndex: "appointment_time_ist",
      key: "appointment_time_ist",
    },
    {
      title: "Full Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "Domain",
      dataIndex: "categoryName",
      key: "categoryName",
    },
    {
      title: "Payment Status",
      dataIndex: "paymentstatus",
      key: "paymentstatus",
      render: (paymentstatus) => {
        const isPaid = paymentstatus?.toLowerCase() === "paid";
        return (
          <div
            style={{
              borderRadius: "5px",
              border: `1px solid ${isPaid ? "#49f5ab" : "#fcd477"}`,
              width: "70px",
              color: isPaid ? "#227451" : "#FEB815",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "30px",
              backgroundColor: isPaid ? "#E1FCEF" : "#FEFFEE",
            }}
          >
            <span>{isPaid ? "Paid" : "Pending"}</span>
          </div>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (_, record) => (
        <a onClick={() => showModal(record.id)} style={{ color: "red" }}>
          Process
        </a>
      ),
    },
  ];

  // Handle loading state
  if (isLoading) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <p>Loading... Please hold on team blaccdot !</p>
      </div>
    );
  }

  const showModal = (_id) => {
    setSelectedId(_id);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedId(null);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setSelectedId(null);
  };

  const filterData = subscriptions.filter((item) =>
    JSON.stringify(item).toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div>
      <Title level={2}>Customized plan table</Title>
      <Card
        style={{ width: "100%" }}
        extra={
          <Input
            placeholder="Search anything..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            prefix={<SearchOutlined style={{ color: "#888" }} />}
            style={{ borderRadius: "5px", padding: "8px 12px" }}
          />
        }
      >
        <Table
          columns={columns}
          dataSource={filterData}
          loading={isLoading}
          rowKey="id" // Map to the unique key from your API
          expandable={{
            expandedRowRender: (record) => (
              <Row>
                <Col md={4}>
                  <div style={{ display: "grid" }}>
                    <p style={{ color: "#595959" }}>Meeting Schedule Request</p>
                    <span className="mb-2">
                      Meeting Date:{" "}
                      {record.appointment_date ? moment(record.appointment_date, "DD-MM-YYYY").format(
                        "DD-MM-YYYY",
                      ) : "N/A"}
                    </span>
                    <span className="mb-2">
                      Meeting Timing: {record.appointment_time || "N/A"}
                    </span>
                    <span className="mb-2 d-flex">
                      Meeting Status:
                      <p
                        style={{
                          color:
                            record.meetingstatus === "null"
                              ? "orange"
                              : record.meetingstatus === "completed"
                                ? "green"
                                : "black",
                          paddingLeft: "10px",
                        }}
                      >
                        {record.meetingstatus || "Pending"}
                      </p>
                    </span>
                  </div>
                </Col>
                <Col md={5}>
                  <div style={{ display: "grid" }}>
                    <p style={{ color: "#595959" }}>General</p>
                    <span className="mb-2">
                      Company Name : {record.brand_name}
                    </span>
                    <span className="mb-2">
                      Company Location : {record.country}
                    </span>
                    <span className="mb-2">
                      Company Start date :{" "}
                      {record.companyStartDate
                        ? moment(record.companyStartDate, "DD-MM-YYYY").format(
                            "DD-MM-YYYY",
                          )
                        : "N/A"}
                    </span>
                    <span className="mb-2">
                      GMB Profile : {record.GMBprofile || "N/A"}
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div style={{ display: "grid" }}>
                    <p style={{ color: "#595959" }}>Customized Data</p>
                    <span className="mb-2">
                      Plan Amount: {record.amount || "N/A"}
                    </span>
                    <span className="mb-2">
                      Credits : {record.creditpoints || "N/A"}
                    </span>
                    <span className="mb-2">
                      Notes:{" "}
                      {record.Notes
                        ? JSON.parse(record.Notes)?.description1 || "N/A"
                        : "N/A"}
                    </span>
                  </div>
                </Col>
              </Row>
            ),
          }}
        />
      </Card>
      <PlanCutomizModel
        tableId={selectedId}
        isModalOpen={isModalOpen}
        onCancel={handleCancel}
        onOk={handleOk}
      />
    </div>
  );
};

export default Customizedplan;

// import React, { useEffect,useState } from 'react';
// import { Card, Table, Modal, notification  } from 'antd';
// import {Row,Col} from 'react-bootstrap'
// import { Link } from 'react-router-dom';
// import Title from "antd/es/typography/Title";
// import { useDispatch, useSelector } from 'react-redux';
// import SubscriptionEditModel from '../components/Modals/SubscriptionEditModel'
// import * as type from '../store/types';
// import PlanCutomizModel from '../components/Modals/PlanCutomizModel';

// const Customizedplan = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedId, setSelectedId] = useState(null) // State to store the selected row's _id
//   const [subscriptions, setSubscriptions] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);

//   // Fetch Data from API
//   const fetchCostomList = async () => {
//     try {
//       const response = await fetch(`https://euctostaging.com/lms/api/businessinitialform/customuser`);
//       if (response.ok) {
//         const result = await response.json();
//         setSubscriptions(result.data); // Map `data` array to the table's `dataSource`
//         setIsLoading(false);
//       } else {
//         const errorData = await response.json();
//         notification.error({
//           message: 'Error',
//           description: errorData.message || 'Failed to fetch data.',
//         });
//         setIsLoading(false);
//       }
//     } catch (error) {
//       notification.error({
//         message: 'Error',
//         description: 'Something went wrong while fetching data.',
//       });
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCostomList();
//   }, []);

//   // Define columns for the Ant Design Table
//   const columns = [
//     {
//       title: 'Full Name',
//       dataIndex: 'name',
//       key: 'name',
//     },
//     {
//       title: 'Email Address',
//       dataIndex: 'email',
//       key: 'email',
//     },
//     {
//       title: 'Phone Number',
//       dataIndex: 'number',
//       key: 'number',
//     },
//     {
//       title: 'Company Name',
//       dataIndex: 'brand_name',
//       key: 'brand_name',
//     },
//     {
//       title: 'Action',
//       dataIndex: '',
//       key: 'x',
//       render: (_, record) => (
//         <a onClick={() => showModal(record.id)} style={{ color: 'red' }}>
//           Process
//         </a>
//       ),
//     },
//   ];

//     // Handle loading state
//     if (isLoading) {
//       return (
//         <div style={{ textAlign: 'center', marginTop: '20px' }}>
//           <p>Loading... Please hold on team blaccdot !</p>
//         </div>
//       );
//     }

//   const showModal = (_id) => {
//     setSelectedId(_id)
//     setIsModalOpen(true);
//   };
//   const handleCancel = () => {
//     setIsModalOpen(false);
//     setSelectedId(null)
//   };
//   const handleOk = () => {
//     setIsModalOpen(false);
//     setSelectedId(null)
//   };

//   // const columns = [
//   //   {
//   //     title: 'Full Name',
//   //     dataIndex: 'title',
//   //     key: 'title',
//   //   },
//   //   {
//   //     title: 'Email Address',
//   //     dataIndex: 'monthAmount',
//   //     key: 'monthAmount',
//   //   },
//   //   {
//   //     title: 'Phone Number',
//   //     dataIndex: 'anualAmount',
//   //     key: 'anualAmount',
//   //   },
//   //   {
//   //     title: 'Company Name',
//   //     dataIndex: 'taxAmount', // Replace if there's a specific field for yearly tax
//   //     key: 'yearlyTax',
//   //   },
//   //   {
//   //     title: 'Payment Status',
//   //     dataIndex: '',
//   //     key: 'y',
//   //     render: (_, record) => (
//   //       <div style={{ borderRadius: '5px', border: '1px solid #E1FCEF',  width: '70px',
//   //         color: '#75B296',  textAlign: 'center', display: 'flex', justifyContent: 'center',
//   //         alignItems: 'center',height: '30px', backgroundColor:'#E1FCEF' }}>
//   //         <span>Paid</span>
//   //       </div>
//   //     ),
//   //   },
//   //   {
//   //     title: 'Action',
//   //     dataIndex: '',
//   //     key: 'x',
//   //     render: (_, record) => (
//   //       <a onClick={()=> showModal(record._id)} style={{ color: 'red' }}>Process</a>
//   //     ),
//   //   },
//   // ];

//   return (
//     <div>
//       <Title level={2}>Customized plan table</Title>
//       <Card style={{ width: '100%' }} >
//         <Table
//           columns={columns} loading={isLoading}
//           dataSource={subscriptions} // Data comes from the Redux state
//           rowKey="_id" // Unique key for each row
//           expandable={{
//             expandedRowRender: (record) => (
//               <Row>
//                 <Col md={4}>
//                 <div style={{ display: 'grid' }}>
//                     <p style={{ color: '#595959' }}>Meeting Schedule Request</p>
//                     <span className="mb-2">Meeting Date: {record.appointment_date || 'N/A'}</span>
//                     <span className="mb-2">Meeting Timing: {record.appointment_time || 'N/A'}</span>
//                     <span className="mb-2 d-flex">
//                       Meeting Status:
//                       <p style={{ color: 'orange', paddingLeft: '10px' }}>
//                         Pending
//                       </p>
//                     </span>
//                   </div>
//                 </Col>
//                 <Col md={4}>
//                   <div style={{display:'grid'}}>
//                   <p style={{color:'#595959'}}>General</p>
//                   <span className="mb-2">Companay Location : Chennai</span>
//                   <span className="mb-2">Companay Start date : Chennai</span>
//                   <span className="mb-2">GMB Profile : www.euctoc.com</span>
//                 </div>
//                 </Col>
//                 <Col md={4}>
//                   <div style={{display:'grid'}}>
//                   <p style={{color:'#595959'}}>Customized Data</p>
//                   <span className="mb-2">Plan Amount: 12,890</span>
//                   <span className="mb-2">Credits : 35000</span>
//                   <span className="mb-2">Notes: The want every week</span>
//                 </div>
//                 </Col>
//               </Row>
//             ),
//           }}
//         />
//       </Card>
//       <PlanCutomizModel isModalOpen={isModalOpen} onCancel={handleCancel} onOk={handleOk} />
//     </div>
//   );
// };

// export default Customizedplan;
